var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTimeOff(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("symbol", {
    id: "icon",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.116 5.3335L5.33301 9.35624L6.6746 10.9479L11.4576 6.92511L10.116 5.3335ZM21.9911 5.3335L20.6515 6.92511L25.4345 10.9479L26.7741 9.35624L21.9911 5.3335ZM16.0535 7.93334C10.88 7.93334 6.6868 12.1265 6.6868 17.3001C6.6868 22.4736 10.88 26.6668 16.0535 26.6668C21.2271 26.6668 25.4203 22.4736 25.4203 17.3001C25.4203 12.1265 21.2271 7.93334 16.0535 7.93334ZM13.3622 13.1371L16.0535 15.8284L18.7449 13.1371L20.2165 14.6088L17.5252 17.3001L20.2165 19.9914L18.7449 21.4631L16.0535 18.7718L13.3622 21.4631L11.8905 19.9914L14.5819 17.3001L11.8905 14.6088L13.3622 13.1371Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeOff);
export default __webpack_public_path__ + "static/media/TimeOff.e9e3ca5d6178c2088d9c3210eb37832e.svg";
export { ForwardRef as ReactComponent };